// extracted by mini-css-extract-plugin
export default {"gauge-charts-container":"ModuloOmnichannel_gauge-charts-container__+6f3k","main-content":"ModuloOmnichannel_main-content__eWG7S"};